<p-tag [value]="situacao | agendamentoSituacao" [severity]="severity" *ngIf="situacao" [styleClass]="styleClass"></p-tag>